const graphProps = {
  aluminum: { name: 'aluminum', color: '#696969' },
  boron: { name: 'boron', color: '#8b4513' },
  calcium: { name: 'calcium', color: '#808000' },
  chromium: { name: 'chromium', color: '#483d8b' },
  copper: { name: 'copper', color: '#008000' },
  iron: { name: 'iron', color: '#008b8b' },
  lead: { name: 'lead', color: '#00008b' },
  magnesium: { name: 'magnesium', color: '#32cd32' },
  molybdenum: { name: 'molybdenum', color: '#8fbc8f' },
  nickel: { name: 'nickel', color: '#800080' },
  phosphorous: { name: 'phosphorous', color: '#b03060' },
  potassium: { name: 'potassium', color: '#ff4500' },
  silicon: { name: 'silicon', color: '#ffa500' },
  silver: { name: 'silver', color: '#00ff00' },
  sodium: { name: 'sodium', color: '#8a2be2' },
  tin: { name: 'tin', color: '#dc143c' },
  zinc: { name: 'zinc', color: '#00ffff' },
  waterPercent: { name: 'waterPercent', title: 'Water (%)', color: '#00bfff' },
  waterPpm: { name: 'waterPpm', title: 'Water (ppm)', color: '#00bfff' },
  newOxidation: { name: 'newOxidation', title: 'Oxidation', color: '#0000ff' },
  newNitration: { name: 'newNitration', title: 'Nitration', color: '#ff7f50' },
  newSulfation: { name: 'newSulfation', title: 'Sulfation', color: '#ff00ff' },
  sootIndex: { name: 'sootIndex', color: '#ffff54' },
  viscosity100c: { name: 'viscosity100c', color: '#add8e6' },
  viscosity40c: { name: 'viscosity40c', color: '#dc7b88' },
  fuelDilution: { name: 'fuelDilution', color: '#ee82ee' },
  antifreeze: { name: 'antifreeze', color: '#98fb98' },
  tan: { name: 'tan', title: 'AN (D664)', color: '#ffdead' },
  tbn: { name: 'tbn', title: 'BN (D4739)', color: '#ffb6c1' },
  bn: { name: 'bn', title: 'BN (D2896)', color: '#c96b79' },
  chlorine: { name: 'chlorine', color: '#ff1493' },
  sulphur: { name: 'sulphur', title: 'Sulfur', color: '#3eccb9' },
  mpc: { name: 'MPC', color: '#d4c3b1' }
};

export default {
  graphProps: Object.values(graphProps),
  legendGroups: [
    [
      graphProps.aluminum.name,
      graphProps.boron.name,
      graphProps.calcium.name,
      graphProps.chromium.name,
      graphProps.copper.name,
      graphProps.iron.name,
      graphProps.lead.name,
      graphProps.magnesium.name,
      graphProps.molybdenum.name,
      graphProps.nickel.name,
      graphProps.phosphorous.name,
      graphProps.potassium.name,
      graphProps.silicon.name,
      graphProps.silver.name,
      graphProps.sodium.name,
      graphProps.tin.name,
      graphProps.zinc.name
    ],
    [
      graphProps.waterPercent.name,
      graphProps.waterPpm.name,
      graphProps.newOxidation.name,
      graphProps.newNitration.name,
      graphProps.newSulfation.name,
      graphProps.sootIndex.name,
      graphProps.viscosity100c.name,
      graphProps.viscosity40c.name,
      graphProps.fuelDilution.name,
      graphProps.antifreeze.name,
      graphProps.tbn.name,
      graphProps.bn.name,
      graphProps.tan.name,
      graphProps.sulphur.name,
      graphProps.chlorine.name,
      graphProps.mpc.name
    ]
  ],
  legendPresets: [
    {
      name: 'None',
      options: []
    },
    {
      name: 'All',
      options: Object.values(graphProps).map(({ name }) => name)
    },
    {
      name: 'Wear Metals',
      options: [
        graphProps.aluminum.name,
        graphProps.chromium.name,
        graphProps.copper.name,
        graphProps.iron.name,
        graphProps.lead.name,
        graphProps.silicon.name
      ]
    },
    {
      name: 'Additive Metals',
      options: [
        graphProps.boron.name,
        graphProps.calcium.name,
        graphProps.magnesium.name,
        graphProps.molybdenum.name,
        graphProps.phosphorous.name,
        graphProps.zinc.name
      ]
    },
    {
      name: 'FTIR',
      options: [graphProps.newNitration.name, graphProps.newOxidation.name, graphProps.newSulfation.name]
    }
  ],
  graphPercentProperties: [
    {
      property: 'waterPercent',
      unitOfMeasure: 'waterUnitOfMeasureName'
    }
  ]
};
